// import { get } from "lodash";

export default {
  getAdminNoticesList: (state) => state.adminNotices.noticesList,
  getAdminNoticePreview: (state) => state.adminNotices.noticePreview,
  getAdminNoticesListFilters: (state) => state.adminNotices.noticesListFilters,
  getAdminNoticeDetails: (state) => state.adminNotices.noticeDetails,
  getAdminNoticesUIState: (state) => state.adminNotices.uiState,
};
